class FieldDataService {
    /**
     * @param {ApiClient} apiClient
     */
    constructor(
        apiClient,
    ) {
        this.apiClient = apiClient;
    }

    /**
     * @param {number} orderID
     * @param {object} data
     *
     * @returns {Promise}
     */
    updateFieldDataForOrder(orderID, data) {
        return this.apiClient
            .request(
                'PATCH',
                `orders/${orderID}/field-data`,
                data
            )
            .then((response) => {
                console.log('Update field data response', response.data);
            });
    }

    /**
     * @param {number} orderID
     * @param {number} fieldID
     * @param {object} data
     *
     * @returns {Promise}
     */
    appendJsonFieldDataForOrderField(orderID, fieldID, data) {
        return this.apiClient
            .request(
                'PATCH',
                `orders/${orderID}/field-data/${fieldID}/json`,
                data
            )
            .then((response) => {
                console.log('Update field data response', response.data);
            });
    }
}

module.exports = FieldDataService;
